import { render, staticRenderFns } from "./transaction-notes-index.vue?vue&type=template&id=7067bd9a"
import script from "./transaction-notes-index.vue?vue&type=script&lang=js"
export * from "./transaction-notes-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports